module.exports = __webpack_public_path__ + "assets/img/img-register-provisional.e0339cd5.gif";